
import LeafIcon from '~/components/ui/LeafIcon';

export default {
  name: 'BlockTextListLeaf',
  components: { LeafIcon },
  props: {
    title: String,
    items: {
      type: Array,
      default: () => [],
    },
    classes: {
      type: Object,
      default: () => {},
    },
    catchphrase: String,
  },
};
